package com.milta.feature.admin.data.remote.dto

import com.milta.feature.admin.domain.entity.AdminAccount
import com.milta.feature.admin.domain.entity.AdminAccounts
import com.milta.feature.admin.domain.entity.AdminOrganisation
import com.milta.feature.admin.domain.entity.AdminSubscription
import kotlinx.serialization.Serializable

// Field names match the backend's camelCase JSON exactly (System.Text.Json default) — see
// Milta.Application.Admin.Dtos.AdminAccountsResponseDto in the milta (backend) repo.

@Serializable
data class AdminAccountsResponseDto(
    val organisations: List<AdminOrganisationDto>,
    val independentDrivers: List<AdminAccountDto>,
)

@Serializable
data class AdminOrganisationDto(
    val enterpriseId: String,
    val name: String,
    val createdAt: String,
    val patron: AdminAccountDto,
    val members: List<AdminAccountDto>,
)

@Serializable
data class AdminAccountDto(
    val accountId: String,
    val firstName: String,
    val lastName: String,
    val email: String?,
    val phoneNumber: String,
    val roles: List<String>,
    val joinedTeamAt: String?,
    val subscription: AdminSubscriptionDto?,
)

@Serializable
data class AdminSubscriptionDto(
    val plan: String,
    val status: String,
    val since: String?,
    val expiresAt: String?,
    val renewalCount: Int,
)

fun AdminAccountsResponseDto.toDomain() = AdminAccounts(
    organisations = organisations.map { it.toDomain() },
    independentDrivers = independentDrivers.map { it.toDomain() },
)

fun AdminOrganisationDto.toDomain() = AdminOrganisation(
    enterpriseId = enterpriseId,
    name = name,
    createdAt = createdAt,
    patron = patron.toDomain(),
    members = members.map { it.toDomain() },
)

fun AdminAccountDto.toDomain() = AdminAccount(
    accountId = accountId,
    firstName = firstName,
    lastName = lastName,
    email = email,
    phoneNumber = phoneNumber,
    roles = roles,
    joinedTeamAt = joinedTeamAt,
    subscription = subscription?.toDomain(),
)

fun AdminSubscriptionDto.toDomain() = AdminSubscription(
    plan = plan,
    status = status,
    since = since,
    expiresAt = expiresAt,
    renewalCount = renewalCount,
)
